<template lang="pug">
  .b-app
    //router-view
    Home
</template>

<script>
  import Home from '@/views/Home';
  export default {
    components: { Home },
    // created() {
    //   this.$loadScript('https://use.fontawesome.com/releases/v5.0.13/js/all.js');
    // },
  };
</script>
